"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LayoutEnum = void 0;
var LayoutEnum;
(function (LayoutEnum) {
    LayoutEnum["Horizontal"] = "horizontal";
    LayoutEnum["Vertical"] = "vertical";
})(LayoutEnum = exports.LayoutEnum || (exports.LayoutEnum = {}));
//# sourceMappingURL=layout-enum.js.map